import MessageList from './List.vue'
import MessageCreate from './Create.vue';
import MessageView from './View.vue';
import AppContainer from '@/container/AppContainer.vue';

export const routes = [
    {
        path: '/messages',
        name: 'messages',
        component: AppContainer,
        children: [
            {
                path: 'new',
                component: MessageCreate,
                meta: {
                    title: "New Message"
                }
            },
            {
                path: ':id',
                component: MessageView,
                meta: {
                    title: "Message"
                }
            },
            {
                path: '/',
                component: MessageList,
                meta: {
                    title: "Messages"
                }
            }
        ]
    }
]
